<template>
  <bc-modal
  name="register-interest"
  variant="fit"
>
    <validation-observer ref="form" v-slot="{ passes, invalid, errors }">
      <div class="p-4 lg:p-8 bg-white dark:bg-gray-800 max-w-xl">
        <slot :form="form" :invalid="invalid"  />
      </div>
      <div class="flex justify-end space-x-3 p-3 w-full bg-gray-100 dark:bg-gray-900 dark:border-gray-800 border-t">
        <bc-button type="button" @click="$modal.hide('register-interest')">
          Cancel
        </bc-button>
        <bc-button type="button" variant="primary" :disabled="invalid" @click="register()">
          Ok, Register Now
        </bc-button>
      </div>
    </validation-observer>

  </bc-modal>
</template>
<script>
export default {
  name: 'RegisterInterest',
  props: {
    programme_id: Number,
    required: true
  },
  data () {
    return {
      loading: false,
      form: {}
    }
  },
  methods: {
    register() {
      axios.post('/api/programmes/'+ this.programme_id +'/interest', this.form )
        .then((response) => {
          this.$dialog.alert({
            title: response.data.title,
            text: response.data.message,
            okButtonText: 'OK'
          })

          this.form = {}

        })
        .catch((err) => {
          this.$dialog.alert({
            title: err.response.data.title,
            text: err.response.data.message,
            okButtonText: 'OK'
          })
        })
        .then(() => {
          this.$modal.hide('register-interest')
          this.loading = false
        })
    }
  }
}
</script>
